import { styled } from '@mui/material/styles';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Container,
  Button,
  Menu,
  IconButton,
  MenuItem,
  Avatar,
} from '@mui/material';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));

export const StyledContainer = styled(Container)({
  maxWidth: 'false',
});

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  disableGutters: true,
  [theme.breakpoints.down('md')]: {
    position: 'relative',
  },
}));

export const MobileMenuContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    position: 'absolute',
    left: '4px',
  },
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

export const DesktopNavContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  justifyContent: 'end',
  flexWrap: 'nowrap',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export const LogoSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flexGrow: 1,
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const DesktopLogo = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(2),
  fontWeight: 700,
  letterSpacing: '.3rem',
  color: 'inherit',
  textDecoration: 'none',
  fontSize: '3em',
  fontStyle: 'normal',
  lineHeight: 1.2,
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export const NavContactIcons = styled(Box)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: theme.spacing(1),
    whiteSpace: 'nowrap',
  },
}));

export const MobileLogo = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  letterSpacing: '.3rem',
  color: 'inherit',
  textDecoration: 'none',
  fontSize: '3em',
  fontStyle: 'normal',
  lineHeight: 1.2,
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'center',
  },
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
  '@media (max-width: 415px)': {
    fontSize: '2.5em',
    flexDirection: 'column',
    lineHeight: 1.1,
    '& span': {
      display: 'block',
    },
  },
}));

export const ContactIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: 'transparent',
  opacity: 0.75,
  transition: theme.transitions.create(['opacity', 'transform'], {
    duration: theme.transitions.duration.shortest,
  }),
  '&:hover': {
    transform: 'translateY(-1px)',
    opacity: 1,
    backgroundColor: 'transparent',
  },
}));

export const ContactIconAvatar = styled(Avatar)({
  width: 28,
  height: 28,
  backgroundColor: 'transparent',
  '& img': {
    objectFit: 'contain',
  },
});

export const NavButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(0.625, 0),
  marginLeft: '5px',
  marginRight: '5px',
  color: 'white',
  fontSize: '1.2em',
  fontStyle: 'normal',
  fontWeight: '400',
  textTransform: 'none',
  lineHeight: 1.5,
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: theme.palette.primary.light,
  },
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginLeft: '-8px',
    padding: '4px',
  },
}));

export const StyledMenuItem = styled(MenuItem)({});

export const StyledMenuButton = styled(Button)({});
